









































































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import {
  InvestmentManagementType,
  DrivewealthWizardStep,
  DrivewealthAccountSummary,
  DrivewealthAccountManagementType
} from "@/shared/types";
import moment from "moment";
import _ from "lodash";
import InvestmentAccountTypeSlots from "@/shared/components/investments/drivewealth/InvestmentAccountTypeSlots.vue";
import InvestmentAccountTypeLink from "@/shared/components/investments/drivewealth/InvestmentAccountTypeLink.vue";
import { Validator } from "vee-validate";
import { formatCurrency } from "@/shared/currency";
import * as RouteNames from "@/employee/route-names";
import WizardProgress from "@/employee/components/investments/drivewealth/wizard/WizardProgress.vue";
import { useEnrollmentStore } from "@/employee/store/enrollment";
import { useDrivewealthWizardStore } from "@/shared/store/drivewealthWizard";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useInvestmentThresholdStore } from "@/shared/store/investmentThreshold";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

@Component({
  components: {
    InvestmentAccountTypeSlots,
    WizardProgress,
    InvestmentAccountTypeLink
  }
})
export default class InvestmentAccountTypeSelector extends Vue {
  $validator: Validator;
  InvestmentManagementType = InvestmentManagementType;
  formatCurrency = formatCurrency;

  @Prop({ required: true })
  isUserOnboarding: boolean;

  @Prop()
  isWizard: boolean;

  @Prop()
  isPreEnrollment: boolean;

  enrollmentStore = useEnrollmentStore();
  drivewealthWizardStore = useDrivewealthWizardStore();
  drivewealthStore = useDrivewealthStore();
  featureFlagStore = useFeatureFlagStore();
  investmentThresholdStore = useInvestmentThresholdStore();
  custodianSettingsStore = useCustodianSettingsStore();

  mounted (): void {
    this.custodianSettingsStore.getCustodianSettings();
    this.investmentThresholdStore.loadInvestmentThresholds({});
    this.enrollmentStore.loadFees();
    this.drivewealthWizardStore.loadBalanceAndIsAllowedToPreenroll({});
    if (this.featureFlagStore.flags.bend15911EnableDrivewealthMultiAccountViews && !this.isPreEnrollment) {
      this.drivewealthStore.loadAccountSummariesV2({});
    }
  }

  get step () {
    return DrivewealthWizardStep.SelectAccountType;
  }

  get isAccountSummariesV2Loaded () {
    let isLoaded = true;
    if (this.featureFlagStore.flags.bend15911EnableDrivewealthMultiAccountViews && !this.isPreEnrollment) {
      isLoaded = this.drivewealthStore.accountSummariesV2Loaded;
    }
    return isLoaded;
  }

  get learnMore () {
    const name = this.isUserOnboarding ? RouteNames.DrivewealthLearnMoreOnboarding : RouteNames.DrivewealthLearnMorePages;

    return {
      name,
      params: {
        subpage: "list"
      }
    };
  }

  setAccountType (accountType: InvestmentManagementType) {
    this.drivewealthWizardStore.selectAccountType(accountType);
  }

  get advisoryAccount (): DrivewealthAccountSummary {
    const account = _.find(this.drivewealthStore.accountSummariesV2,
      x => x.accountManagementType === DrivewealthAccountManagementType.Advisory);

    return account;
  }

  get openBrokerageAccount (): DrivewealthAccountSummary {
    const account = _.find(this.drivewealthStore.accountSummariesV2,
      x => x.accountManagementType === DrivewealthAccountManagementType.OpenBrokerage);

    return account;
  }

  get managedAccount (): DrivewealthAccountSummary {
    const account = _.find(this.drivewealthStore.accountSummariesV2,
      x => x.accountManagementType === DrivewealthAccountManagementType.RiaManaged);

    return account;
  }

  get limitCopy () {
    const limit = formatCurrency(this.investmentThresholdStore.investmentThreshold());
    return "Only funds more than " + limit + " in your HSA cash balance may be invested.";
  }

  get secondFootnote () {
    return this.custodianSettingsStore.isHsaBankCustodian ? "2" : "1";
  }

  get showHsabNote () {
    return this.custodianSettingsStore.isHsaBankCustodian && moment().year() === 2024;
  }
}
